// ! this file should only be directly modified in the packages/corso-types/corso-shopify-extensions/shared.ts file
// ! IT SHOULD NOT CONTAIN ANY IMPORTS!!!!!
export const CorsoCurrencyMetaobject = {
    type: 'currency',
    handle: 'corso_currency',
    fieldKey: 'conversion_rate',
    value: 100000,
};
export const CheckoutPlusUrlParam = {
    sfToken: 'sfToken',
    shop: 'shop',
};
export const CorsoMetafieldNamespace = `$app:corso`;
export const CorsoMetafieldKey = {
    WIDGET_CONFIG: 'widget_config',
    SHIPPING_PLUS_PRICE: 'plus_shipping_price',
    // the pricing set for the store
    CART_PRICE_RANGES: 'cart_price_ranges',
};
export const CORSO_FUNCTION_NAME = {
    reorderShippingLines: 'Corso Reorder Shipping Lines',
    shippingDiscount: 'Corso Shipping Discount',
};
//  the title of the delivery customization
export const CORSO_DELIVERY_CUSTOMIZATION_TITLE = 'Corso Delivery Customization';
// the name of the carrier service
export const CORSO_CARRIER_SERVICE_NAME = 'Corso';
// ---------- CART ATTRIBUTE -----------------------------------
//! attributes must be between 3-30 characters in length
export const CorsoCartAttribute = {
    plusTitle: '_corsoSpTitle',
    plusPrice: '_corsoSpPrice',
    dgShippingGuaranteed: '_corsoSpGuarantee',
    discountName: '_corsoSpDiscount',
    dgGuaranteeOptOutOn: '_corsoSpDgOptOutOn',
    dgCheckboxSelected: '_corsoSpDgOptOut',
    //! do not modify this without updating the corso-reorder-shipping-lines function
    cpReorderOptIn: '_corsoCpReorderOptIn',
};
export const CorsoLineItemProperty = {
    deliveryGroupType: '_corsoDeliveryGroupType',
    customer: `_corsoCustomer`,
    discountedPrice: '_corsoDiscountedPrice',
};
export const CheckoutPlusInsertionStrategy = {
    insertAdjacentBeforeBegin: 'insertAdjacentBeforeBegin',
    insertAdjacentAfterBegin: 'insertAdjacentAfterBegin',
    insertAdjacentBeforeEnd: 'insertAdjacentBeforeEnd',
    insertAdjacentAfterEnd: 'insertAdjacentAfterEnd',
};
export const CheckoutPlusAction = {
    setShippingPlusReorderRate: 'setShippingPlusReorderRate',
    setShippingPlusOptOut: 'setShippingPlusOptOut',
    addVariantToCart: 'addVariantToCart',
};
export const CheckoutPlusElementKind = {
    altCheckoutButton: 'altCheckoutButton',
    checkoutInfo: 'checkoutInfo',
};
export const CartChangeDetectionMethod = {
    cartWatcher: 'cartWatcher',
    selectorObserver: 'selectorObserver',
};
export const CheckoutPlusTemplateVariable = {
    subtotal: 'subtotal',
    quotePrice: 'quotePrice',
};
export function decodeCorsoShippingCode(code) {
    try {
        if (!code)
            return null;
        const parsed = JSON.parse(code);
        if (typeof parsed === 'object' && parsed !== null && 'rateKind' in parsed) {
            return parsed;
        }
    }
    catch (error) {
        /* empty */
    }
    return null;
}
const mockWidgetConfig = (partial) => ({
    ...partial,
    modal: {
        imageUrl: 'https://cdn.corso.com/img/shipping-plus-hexagon-banner.png',
        title: `Shipping Plus`,
        description: "Get streamlined resolution in case anything unexpected happens to your package. For a small optional amount, you don't have to worry.",
        benefits: [
            {
                title: `Shipping Plus has you covered`,
                description: 'For loss, damage, theft, missing or wrong items, return to sender, and other carrier mistakes.',
            },
            {
                title: 'Fast, Friendly Support',
                description: 'Get quick help from the friendly team at Corso. They have seen everything and have a 97% customer satisfaction score.',
            },
            {
                title: 'Easy Resolutions Replacements',
                description: 'Our Shipping Plus customer portal makes it very easy to report a shipping issue and fast-track a replacement.',
            },
        ],
    },
    shippingPlus: {
        isFreeShippingOptInEnabled: false,
        deliveryCustomization: {
            hideRateNames: [],
            isEnabled: true,
            isReorderShippingLinesEnabled: false,
        },
        label: 'Learn About Shipping Plus',
        freeShippingLabel: `I've Read The Free Shipping Policy`,
        freeShippingDescription: 'If you select a free shipping option, we are not responsible for shipping mistakes or stolen packages.',
        description: `If you don't select a Shipping Plus option, we are not responsible for shipping mistakes or stolen packages.`,
    },
});
const mockShippingCode = (partial) => ({
    ...partial,
    rateKind: 'plus',
});
export const extensionTestUtils = {
    mockShippingCode,
    mockWidgetConfig,
};
//# sourceMappingURL=shared.js.map